import { Component, OnInit, Input } from '@angular/core';
import { BillingFormComponent } from 'ngx-intellforce-billing/lib/components/billing-form/billing-form.component';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  @Input() form!: BillingFormComponent;
  constructor() { }

  ngOnInit() {
  }

}
